module.exports = __webpack_public_path__ + "img/thank-you-header.fe089f3f.svg";